import React from 'react';
import { Input, Label } from '@gjensidige/builders-components';
import './InsuranceTileFooter.scss';
import { Package } from '../../../interfaces/Types';

interface Props {
  data: Package;
  /**
   * Handle side effects of updating the Tile selection
   */
  updateTileSelection: (selectedTile: any) => void;
}

export type ComponentProps = Props;

const InsuranceTileFooter: React.FC<ComponentProps> = (props) => {
  const getBottomClassName = () => {
    let className = '';
    if (props.data.isPlusPackage) {
      className = `pluspacket-section ${
        props.data.detailText ? 'no-border-bottom' : ''
      }`;
    }
    return className;
  };

  return (
    <>
      <div>
        <div
          className="tile-container-div"
        >
          <div className={`bottom-container ${getBottomClassName()}`}>
            <div>
                <Label>
                  <Input
                    type="checkbox"
                    id={`selector-checkbox-${props.data.packageName}`}
                    name={props.data.packageName}
                    value={props.data.packageName}
                    checked={props.data.isSelected}
                    onChange={() => props.updateTileSelection(props.data)}
                  />
                  {props.data.packageSelectLabel}
                </Label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default InsuranceTileFooter;
